// CRM Lead Service - Frontend Helper
// Use this in your React frontend to submit leads securely

/**
 * Encrypts userId using Base64 encoding
 * @param {string} userId - The user ID to encrypt
 * @returns {string} Encrypted userId
 */
export const encryptUserId = (userId) => {
  try {
    // Simple Base64 encoding
    return btoa(userId);
  } catch (error) {
    console.error("Encryption error:", error);
    throw new Error("Failed to encrypt user ID");
  }
};

/**
 * Submits lead data to Firebase Cloud Function
 * @param {Object} leadData - The lead form data
 * @param {string} userId - The user ID (will be encrypted automatically)
 * @returns {Promise} Response from the API
 */
export const submitLeadToFirebase = async (leadData, userId) => {
  try {
    // Encrypt userId
    const encryptedData = encryptUserId(userId);

    // Prepare the payload
    const payload = {
      firstName: leadData.firstName,
      lastName: leadData.lastName,
      email: leadData.email,
      mobile: leadData.mobile,
      countryCode: leadData.countryCode || "+91",
      message: leadData.message,
      country: leadData.country || "",
      company: leadData.company || "",
      source: leadData.source || "Website Contact Form",
      type: leadData.type || "Export",
      encryptedData: encryptedData, // Send encrypted userId
    };

    // Replace with your actual Firebase Function URL after deployment
    const FIREBASE_FUNCTION_URL =
      "https://createleadfromwebsite-3jje2wggzq-uc.a.run.app";

    const response = await fetch(FIREBASE_FUNCTION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.msg || "Failed to submit lead");
    }

    return data;
  } catch (error) {
    console.error("Lead submission error:", error);
    throw error;
  }
};
